import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLang } from '../context/LangContext';
import { mockMaps } from '../data/mockMaps';
import MapCard from '../components/MapCard';
import { MapCardSkeleton } from '../components/Skeleton';

export default function Home() {
  const { t } = useLang();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen pb-20">
      <div className="relative py-20 px-4 sm:px-6 lg:px-8 overflow-hidden flex flex-col items-center text-center">
        <div className="absolute inset-0 z-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-slate-800 via-slate-950 to-slate-950"></div>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="relative z-10 max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-black uppercase italic tracking-tighter mb-4 text-glow leading-tight">
            {t('home_title')}
          </h1>
          <p className="text-xl md:text-2xl text-slate-400 font-medium max-w-2xl mx-auto">
            {t('home_subtitle')}
          </p>
        </motion.div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-2xl font-black uppercase italic border-l-4 border-lime-400 pl-3">
            {t('explore')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {loading ? (
            Array(6).fill(0).map((_, i) => <MapCardSkeleton key={i} />)
          ) : (
            mockMaps.map((map, i) => (
              <motion.div
                key={map.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1 }}
              >
                <MapCard map={map} />
              </motion.div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}